// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
// Container imports
const profileUserActions = require('../profile-user/actions')
const UserProfileSocialNav = require('./component-dumb')

function mapStateToProps(state) {
  const {
    profileUser,
    profileUserStats
  } = state
  return {
    isSelfProfile: profileUser.id === state.user.id,
    selected: selectedState(state),
    profileUser,
    profileUserStats
  }
}

const mapDispatchToProps = {
  onFollowersClick: profileUserActions.navigateToUserProfileFollowers,
  onFollowingClick: profileUserActions.navigateToUserProfileFollowing
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withImmutableToJS(
    UserProfileSocialNav
  )
)

function selectedState(state) {
  switch (state.router.action) {
    case 'user-profile.showFollowers':
      return 'followers'
    case 'user-profile.showFriends':
      return 'following'
    default:
      return null
  }
}
